// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from "vuex";
import error from '../../../../common/nodejs/errors';
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import util from "../../../../share/util/utils";
import cstmTable from "../../../../share/components/vue/PaginationTable.vue";

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  REGISTERED: 'registered', // 登録済表示
  WARNING: 'warning', // 警告表示
  INPUT_DATA: 'inputData', //入力表示
  SAVE_DATA: 'saveData', // データ書込み
  SUCCESS: 'success', // 停止
  OVER_SPEED_ERROR: 'overSpeedError', // 車輪速超過表示
  SELECT_ERROR: 'selectError', // パラメータ選択不可
  FRAUD_ERROR: 'fraudError', // バリアントデータ不正
  APPLIED_MODEL_UNDEFINED: 'appliedModelUndefined', // アプライドモデル未定義
  APPLIED_MODEL_ANOMALY: 'appliedModelAnomaly', // アプライドモデル異常
  ERROR: 'error' // 共通エラー 
};

const VALIDATE = {
  APPLIED_MODEL: 7,
  OP_CODE: 4
};

/** API type定義 */
const API_TYPE = {
  STANDBY: 'standby',
  EXECUTE_VARIANT: 'execute_variant',
  EXECUTE_VARIANT_WARN: 'execute_variant_warn',
  SEC_ACCESS: 'sec_access',
  INITIALIZE_VARIANT: 'initialize_variant',
  INITIALIZE_PARAM: 'initialize_param',
  MATCH_INPUT: 'match_input',
  MATCH_ROMID: 'match_romid',
  SESSION: 'session',
  WRITE_SEC_ERR: 'write_sec_err',
  TERMINATE: 'terminate',
  DISPOSE: 'dispose'
};

/** 現在セッション */
const SESSION_PROPERTY = {
  DEFAULT: 0,
  NON_DEFAULT: 1
};

export default {
  name: "requirement115",
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      sessionProperty: SESSION_PROPERTY.DEFAULT,
      isDispose: true,
      validateAppliedModel: undefined,
      validateOptionCode: undefined,
      modelTableItems: [],
      modelBodyItems: [],
      gradeTableItems: [],
      gradeBodyItems: [],
      appliedModel: '',
      optionCode: '',
      model: "",
      engine: "",
      gear: "",
      isSuccessGetVariantData: false,
      timer: undefined,
      waitTime: 0,
      modal_requirement_115: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: "", required: true },
    workSupportId: { type: Number, default: "", required: true }
  },

  components: {
    "cstm-table": cstmTable
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.OVER_SPEED_ERROR:
        case PHASE.SELECT_ERROR:
        case PHASE.FRAUD_ERROR:
        case PHASE.APPLIED_MODEL_UNDEFINED:
        case PHASE.APPLIED_MODEL_ANOMALY:
        case PHASE.ERROR:
          return "danger";
        case PHASE.REGISTERED:
        case PHASE.WARNING:
          return 'warning';
        case PHASE.SUCCESS:
          return "success";
        case PHASE.START:
        case PHASE.SAVE_DATA:
        case PHASE.INPUT_DATA:
        default:
          return "secondary";
      }
    },

    /** アプライドモデル表示用 */
    modelTableColumns() {
      this.modelTableItems = [
        {
          name: "itemName",
          label: `individual.label_table_7digit_model`
        }
      ];
      return this.modelTableItems;
    },

    /** グレード表示用 */
    gradeTableColumns() {
      this.gradeTableItems = [
        {
          name: "itemModel",
          label: `individual.label_table_car_model`
        }
        ,
        {
          name: "itemEngine",
          label: `individual.label_table_engine`
        },
        {
          name: "itemGear",
          label: `individual.label_table_transmission`
        }
      ];
      return this.gradeTableItems;
    },
  },

  methods: {
    ...mapActions("auth", ["logout", "resetSession"]),

    /** 初期化処理 */
    init() {
      this.isSuccessGetVariantData = false;
      this.modal_requirement_115 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit("close-wizard");
      this.modal_requirement_115 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 共通エラー画面の場合は、ウィザードを閉じる
      if (this.phase === PHASE.ERROR) {
        this.closeWizard();
        return;
      }
      this.isLoading = false;
      // 異常終了：エラー表示
      this.phase = PHASE.ERROR;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** メニュー選択時の処理 */
    async startProc() {
      try {
        this.isLoading = true;

        // 待機処理
        if (!await this.doStandby()) {
          return;
        }
        // キャリブレーション状態初期化(パラメータ初期化)
        await this.doInitializeParam();

      } finally {
        this.isLoading = false;
      }
    },

    /** バリアントデータ登録済み時の処理 */
    async registeredProc() {
      try {
        this.isLoading = true;

        // バリアントデータ登録済み時の処理
        if (!await this.doExecuteVariant()) {
          return;
        }

        // セキュリティアクセス判定
        if (!await this.doSecAccess()) {
          return;
        }

        // バリアントコード初期化
        if (!await this.doInitializeVariant()) {
          return;
        }

        // キャリブレーション状態初期化(パラメータ初期化)
        await this.doInitializeParam();

      } finally {
        this.isLoading = false;
      }
    },

    /** 登録済表示時の計測時間到達時の処理 */
    async registeredTimeout() {
      clearTimeout(this.timer);
      await this.doDispose();
      this.closeWizard();
    },

    /** 警告表示時の処理 */
    async warningProc() {
      try {
        this.isLoading = true;

        // 警告表示時の処理
        if (!await this.doExecuteVariantWarn()) {
          return;
        }

        // セキュリティアクセス判定
        if (!await this.doSecAccess()) {
          return;
        }

        // バリアントコード初期化
        if (!await this.doInitializeVariant()) {
          return;
        }

        // キャリブレーション状態初期化(パラメータ初期化)
        await this.doInitializeParam();

      } finally {
        this.isLoading = false;
      }
    },

    /** 警告表示時の計測時間到達時の処理 */
    async warningTimeout() {
      clearTimeout(this.timer);
      await this.doTerminate();
    },

    /** アプライドモデル・オプションコード入力時の処理 */
    async inputDataProc() {
      try {
        this.isLoading = true;
        // 一致判定
        if (!await this.doMatchInput()) {
          return;
        }

        // DefaultSession遷移
        if (!await this.doTerminate()) {
          return;
        }

        // 時間計測
        await util.sleep(this.waitTime);

        // バリアントデータ判定
        await this.doMatchRomid();

      } finally {
        this.isLoading = false;
      }
    },

    /** バリアントデータ不正表示時の処理 */
    async doExecuteVariantWrongProc() {
      try {
        this.isLoading = true;
        // NonDefaultSession遷移
        if (!await this.doSession()) {
          return;
        }

        // セキュリティアクセス判定
        if (!await this.doSecAccess()) {
          return;
        }

        // データ書込み
        if (!await this.doWriteSecErr()) {
          return;
        }

        // DefaultSession遷移
        await this.doTerminate();

      } finally {
        this.isLoading = false;
      }
    },

    /** 待機 */
    async doStandby() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.STANDBY
      };

      // standby API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            this.waitTime = response.data.user_data.wait_time;
            this.isSuccessGetVariantData = true;
            // 現在セッション更新（NonDefaultSession）
            this.sessionProperty = SESSION_PROPERTY.NON_DEFAULT;
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              case error.WSP_115_GET_VARIANTDATA_FAILED:
                // バリアントデータ取得失敗の場合は共通エラー
                this.showUnexpectedError();
                break;
              case error.WSP_115_REGISTERED_FAILED:
                this.isSuccessGetVariantData = true;
                // バリアントデータ登録済表示
                this.phase = PHASE.REGISTERED;
                this.waitTime = response.data.user_data.wait_time;
                // 時間計測
                this.timer = setTimeout(this.registeredTimeout, this.waitTime);
                break;
              case error.WSP_115_OVER_SPEED_FAILED:
                this.isSuccessGetVariantData = true;
                // 車輪速超過表示
                this.phase = PHASE.OVER_SPEED_ERROR;
                this.waitTime = response.data.user_data.wait_time;
                await this.measureTimeBeforeTerminate();
                break;
              case error.WSP_GENERAL_ERROR:
                // disposeが必要か
                this.isDispose = response.data.user_data.is_dispose;
                this.showUnexpectedError();
                break;
              default:
                this.isSuccessGetVariantData = true;
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** バリアントデータ登録済表示時の処理 */
    async doExecuteVariant() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.EXECUTE_VARIANT
      };

      // execute_variant API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;
      // res_type で 分岐 する。
      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 現在セッション更新（NonDefaultSession）
            this.sessionProperty = SESSION_PROPERTY.NON_DEFAULT;
            // 正常終了
            switch (response.data.user_data.res_type) {
              case "ok":
                isSuccess = true;
                break;
              case "warn":
                // 警告表示
                this.phase = PHASE.WARNING;
                this.waitTime = response.data.user_data.wait_time;
                // 時間計測
                this.timer = setTimeout(this.warningTimeout, this.waitTime);
                break;
              default:
                break;
            }
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              case error.WSP_115_OVER_SPEED_FAILED:
                // 車輪速超過表示
                this.phase = PHASE.OVER_SPEED_ERROR;
                this.waitTime = response.data.user_data.wait_time;
                await this.measureTimeBeforeTerminate();
                break;
              case error.WSP_115_SELECT_ERROR_FAILED:
                // パラメータ選択不可表示
                // 現在セッション更新（NonDefaultSession）
                this.sessionProperty = SESSION_PROPERTY.NON_DEFAULT;
                this.phase = PHASE.SELECT_ERROR;
                this.waitTime = response.data.user_data.wait_time;
                await this.measureTimeBeforeTerminate();
                break;
              case error.WSP_GENERAL_ERROR:
                // 現在セッション更新
                // NonDefaultSession遷移異常終了 sessionProperty: DEFAULT(0)
                // データ読出し異常終了 sessionProperty: NON_DEFAULT(1)
                this.sessionProperty = response.data.user_data.session_property;
                this.showUnexpectedError();
                break;
              default:
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** 警告表示時の処理 */
    async doExecuteVariantWarn() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.EXECUTE_VARIANT_WARN
      };

      // execute_variant_warn API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              case error.WSP_115_SELECT_ERROR_FAILED:
                // パラメータ選択不可表示
                this.phase = PHASE.SELECT_ERROR;
                this.waitTime = response.data.user_data.wait_time;
                await this.measureTimeBeforeTerminate();
                break;
              default:
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** セキュリティアクセス判定 */
    async doSecAccess() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.SEC_ACCESS
      };

      // 初期処理（要求）
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバックを実装する。
        // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 共通エラー
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** バリアントコード初期化 */
    async doInitializeVariant() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.INITIALIZE_VARIANT
      };

      // initialize_variant API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              case error.WSP_115_SELECT_ERROR_FAILED:
                // パラメータ選択不可表示
                this.phase = PHASE.SELECT_ERROR;
                this.waitTime = response.data.user_data.wait_time;
                await this.measureTimeBeforeTerminate();
                break;
              default:
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** キャリブレーション状態初期化(パラメータ初期化) */
    async doInitializeParam() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.INITIALIZE_PARAM
      };

      // initialize_param API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            this.phase = PHASE.INPUT_DATA;
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              case error.WSP_115_SELECT_ERROR_FAILED:
                // パラメータ選択不可表示
                this.phase = PHASE.SELECT_ERROR;
                this.waitTime = response.data.user_data.wait_time;
                await this.measureTimeBeforeTerminate();
                break;
              default:
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }
    },

    /** バリアントデータ不正表示での時間計測 */
    async measureTimeFraud() {
      this.isLoading = false;
      // 5秒待ち
      await util.sleep(this.waitTime);

      // バリアントデータ不正表示時の処理
      await this.doExecuteVariantWrongProc();
    },

    /** 時間計測後終了処理 */
    async measureTimeBeforeTerminate() {
      this.isLoading = false;
      // 5秒待ち
      await util.sleep(this.waitTime);

      // DefaultSession遷移
      if (!await this.doTerminate()) {
        return;
      }
    },

    /** アプライドモデル・オプションコード入力 */
    async doMatchInput() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.MATCH_INPUT,
        applied_model: this.appliedModel,
        option_code: this.optionCode
      };

      // match_input API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            this.phase = PHASE.SAVE_DATA;
            this.waitTime = response.data.user_data.wait_time;
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              case error.WSP_115_APPLIED_MODEL_UNDEFINED:
                if (this.optionCode !== '') {
                  // アプライドモデル未定義で、オプションコードが入力されている場合は、オプションコードを空にして再度実行する
                  this.optionCode = '';
                  // オプションコードを空に設定して再実行
                  return await this.doMatchInput();
                }
                // アプライドモデル未定義表示
                this.phase = PHASE.APPLIED_MODEL_UNDEFINED;
                this.waitTime = response.data.user_data.wait_time;
                await this.measureTimeBeforeTerminate();
                break;
              case error.WSP_115_APPLIED_MODEL_ANOMALY_FAILED:
                // アプライドモデル異常表示
                this.phase = PHASE.APPLIED_MODEL_ANOMALY;
                this.waitTime = response.data.user_data.wait_time;
                await this.measureTimeBeforeTerminate();
                break;
              case error.WSP_115_SELECT_ERROR_FAILED:
                // パラメータ選択不可表示
                this.phase = PHASE.SELECT_ERROR;
                this.waitTime = response.data.user_data.wait_time;
                await this.measureTimeBeforeTerminate();
                break;
              default:
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** バリアントデータ判定 */
    async doMatchRomid() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.MATCH_ROMID,
        applied_model: this.appliedModel,
        option_code: this.optionCode
      };

      // match_romid API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            this.phase = PHASE.SUCCESS;
            // データをセット
            this.$nextTick(() => {
              // アプライドモデル表示用のデータ作成
              this.modelBodyItems = [
                {
                  itemID: 0,
                  itemName: response.data.user_data.seven_digit_model_code[0]
                }
              ];
            });

            if (this.$parent.$i18n.locale === 'ja') {
              // 表示言語が日本語
              this.$nextTick(() => {
                // グレード表示用のデータ作成
                this.gradeBodyItems = [
                  {
                    itemID: 0,
                    itemModel: response.data.user_data.option_code[0].model,
                    itemEngine: response.data.user_data.option_code[0].engine,
                    itemGear: response.data.user_data.option_code[0].transmission1
                  }
                ];
              });
            } else {
              // 表示言語が日本語以外
              this.$nextTick(() => {
                // グレード表示用のデータ作成
                this.gradeBodyItems = [
                  {
                    itemID: 0,
                    itemModel: response.data.user_data.option_code[0].model,
                    itemEngine: response.data.user_data.option_code[0].engine,
                    itemGear: response.data.user_data.option_code[0].transmission2
                  }
                ];
              });
            }
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              case error.WSP_115_VARIANT_DATA_FRAUD:
                // バリアントデータ不正表示
                this.phase = PHASE.FRAUD_ERROR;
                await this.measureTimeFraud();
                break;
              default:
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }
    },

    /** NonDefaultSession遷移処理 */
    async doSession() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.SESSION
      };

      // 初期処理（要求）
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバックを実装する。
        // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            isSuccess = true;
            // 現在セッション更新（NonDefaultSession）
            this.sessionProperty = SESSION_PROPERTY.NON_DEFAULT;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 共通エラー
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** バリアントデータ不正表示でのデータ書込み処理 */
    async doWriteSecErr() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.WRITE_SEC_ERR
      };

      // 初期処理（要求）
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバックを実装する。
        // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 共通エラー
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** DefaultSession遷移時の処理 */
    async doTerminate() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.TERMINATE,
        };

        // terminate API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        let isSuccess = false;

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              // 現在セッション更新（DefaultSession）
              this.sessionProperty = SESSION_PROPERTY.DEFAULT;
              if (this.phase !== PHASE.SAVE_DATA) {
                // 書込み画面以外は、disposeAPIを実施してウィザードを閉じる
                await this.doDispose();
                this.closeWizard();
              }
              isSuccess = true;
              break;
            case config.STATUS_WSP_FAILED:
              if (this.phase === PHASE.ERROR) {
                // 共通エラー画面の場合は、disposeAPIを実施してウィザードを閉じる
                await this.doDispose();
                this.closeWizard();
              } else {
                this.showUnexpectedError();
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
        return isSuccess;
      } finally {
        // 書込み中画面の場合はスピナーを非表示にしない
        if (this.phase !== PHASE.SAVE_DATA) {
          this.isLoading = false;
        }
      }
    },

    /** 終了時の処理 */
    async doDispose() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.DISPOSE
        };

        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

      } finally {
        this.isLoading = false;
      }
    },

    /** バリアントデータ登録済表示 OKボタン押下 */
    async onRegisteredOkClicked() {
      clearTimeout(this.timer);
      this.registeredProc();
    },

    /** 警告表示 YESボタン押下 */
    async onWarningOkClicked() {
      clearTimeout(this.timer);
      this.warningProc();
    },

    /** 警告表示 NOボタン押下 */
    async onWarningNoClicked() {
      clearTimeout(this.timer);
      this.doTerminate();
    },

    /** アプライドモデル・オプションコード入力表示 OKボタン押下 */
    async onInputDataOkClicked() {
      if (this.checkValidateAppliedModel() && this.checkValidateOptionCode()) {
        this.inputDataProc();
      }
    },

    /** アプライドモデル・オプションコード入力表示 キャンセルボタン押下 */
    async onInputDataNoClicked() {
      await this.doTerminate();
    },

    /** 停止表示 OKボタン押下 */
    async onSuccessOkClicked() {
      await this.doDispose();
      this.closeWizard();
    },

    /** 共通エラー画面 OKボタン押下 */
    async onErrorOkClicked() {
      // 現在セッションがNonDefaultSessionの場合はterminateを実行する
      if (this.sessionProperty === SESSION_PROPERTY.NON_DEFAULT) {
        this.doTerminate();
      } else {
        if (this.isDispose) {
          // disposeが必要か
          await this.doDispose();
          this.closeWizard();
        } else {
          // [REQ.WS.115.SBY.2] で共通エラーに遷移した場合はCCとの通信がないためdispose不要
          this.closeWizard();
        }
      }
    },

    /**
     * バリデーションチェック(アプライドモデル)
     * @returns 確認結果 (true: OK, false: NG)
     */
    checkValidateAppliedModel() {
      this.validateAppliedModel = undefined;

      // 空の場合エラー
      if (!this.appliedModel) {
        this.validateAppliedModel = { valid: true, msg: this.$t(`message.alert_validate_required`) };
        return false;
      }
      // 不正文字列が含まれている場合はエラー
      if (this.checkInvalidCharacter(this.appliedModel)) {
        this.validateAppliedModel = { valid: true, msg: this.$t(`message.alert_validate_invalid_pattern`) };
        return false;
      }
      // 桁数が7桁でない場合はエラー
      if (this.appliedModel.length !== VALIDATE.APPLIED_MODEL) {
        this.validateAppliedModel = { valid: true, msg: this.$t(`message.alert_validate_max_length`, ['7']) };
        return false;
      }
      // OK判定
      return true;
    },

    /**
     * バリデーションチェック(OPコード)
     * @returns 確認結果 (true: OK, false: NG)
     */
    checkValidateOptionCode() {
      this.validateOptionCode = undefined;
      // 不正文字列が含まれている場合はエラー
      if (this.checkInvalidCharacter(this.optionCode)) {
        this.validateOptionCode = { valid: true, msg: this.$t(`message.alert_validate_invalid_pattern`) };
        return false;
      }
      // 4桁ではない、かつ、空白でない場合はエラー
      if (this.optionCode.length !== VALIDATE.OP_CODE && this.optionCode !== "") {
        this.validateOptionCode = { valid: true, msg: this.$t(`message.alert_validate_max_length`, ['4']) };
        return false;
      }
      // OK判定
      return true;
    },

    /**
     * 使用不可な文字列が含まれていないかの確認関数
     * @param code 対象code
     */
    checkInvalidCharacter(code) {
      // 半角英数字以外の場合は弾く
      const halfReqExp = new RegExp(/^[A-Za-z0-9]*$/);
      return !halfReqExp.test(code);
    },
  },

  async mounted() {
    this.init();

    // メニュー選択時の処理
    this.startProc();
  }
};
